<template>
  <div class="home-container">

  </div>
</template>

<style>
</style>

<script>
import * as clientUtils from "@/axios/ClientUtils";
//pc/mobile判断标识符
import {isMobile} from 'react-device-detect';

export default {
  name: "generalTemplate",
  data() {
    return {}
  },
  methods: {

    getQueryString: function (name) {
      let reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i");
      let r = window.location.search.substr(1).match(reg);
      if (r != null) {
        return decodeURIComponent(r[2]);
      }
      return null;
    }

  },


  mounted() {

    //获取域名，在这里判断结束之后存app_id
    var domain = window.location.host;
    if (domain === "synuloginv2.service.timkj.cn") {
      localStorage.setItem('app_id', 1)
      //判断是pc还是手机
      if (isMobile) {
        console.log('手机')
        this.$router.replace('userLogInPC')
      } else {
        console.log("PC")
        this.$router.replace('userLogInPC')
      }
    } else if (domain === "lfloginv2.service.timkj.cn") {
      localStorage.setItem('app_id', 4)
      //判断是pc还是手机
      if (isMobile) {
        console.log('手机')
        this.$router.replace('userLogInPC')
      } else {
        console.log("PC")
        this.$router.replace('userLogInPC')
      }
    } else if (domain === "sycmloginv2.service.timkj.cn") {
      localStorage.setItem('app_id', 5)
      //判断是pc还是手机
      if (isMobile) {
        console.log('手机')
        this.$router.replace('userLogInPC')
      } else {
        console.log("PC")
        this.$router.replace('userLogInPC')
      }
    } else if (domain === "yyjsloginv2.service.timkj.cn") {
      localStorage.setItem('app_id', 6)
      //判断是pc还是手机
      if (isMobile) {
        console.log('手机')
        this.$router.replace('userLogInPC')
      } else {
        console.log("PC")
        this.$router.replace('userLogInPC')
      }
    } else if (domain === "dhdloginv2.service.timkj.cn") {
      localStorage.setItem('app_id', 2)

      let token = this.getQueryString("third_token")

      if (token === null) {
        //判断是pc还是手机
        if (isMobile) {
          console.log('手机')
          this.$router.replace('userLogInPC')
        } else {
          console.log("PC")
          this.$router.replace('userLogInPC')
        }
      } else {
        let obj = {
          "type": 1,
          "token": token
        }
        const that = this
        clientUtils.post("/autoLogin/v2/pub/auth/login/thirdAuth", obj, function (res) {
          if (res.data.code === 0) {
            console.log(res)
            let token = res.data.data
            localStorage.setItem("token", token)
            that.$router.replace('AppListPC')
          } else {
            that.$notify.error({
              title: res.data.msg,
              message: res.data.data
            })

          }
        })
      }

    } else if (domain === "lnzyloginv2.service.timkj.cn") {
      localStorage.setItem('app_id', 3)
      //判断是pc还是手机
      if (isMobile) {
        console.log('手机')
        this.$router.replace('userLogInPC')
      } else {
        console.log("PC")
        this.$router.replace('userLogInPC')
      }
    } else if (domain === "testv2.service.timkj.cn") {    //测试学校
      localStorage.setItem('app_id', 7)
      //判断是pc还是手机
      if (isMobile) {
        console.log('手机')
        this.$router.replace('userLogInPC')
      } else {
        console.log("PC")
        this.$router.replace('userLogInPC')
      }
    } else {
      // localStorage.setItem('app_id', 1)
      // this.$router.replace('userLogInPC')
      this.$router.replace('noAuth')
    }


  }

}
</script>

<style lang="scss" scoped>
.home-container {
  height: 100vh;
}

// 侧边栏
.el-aside {
  background-color: #fff;
}

// 主体区域
.el-main {
  background-color: #eff1f7;
}

// 头部区域下拉选项
.el-header {
  width: 100%;
  padding: 0 13px;
  background-color: #fff;
  display: flex;
  align-items: center;
  justify-content: space-between;

  .header-left {
    width: 24em;
    display: flex;
    align-items: center;
    justify-content: space-between;

    .logoTitle {
      font-size: 16px;
      font-weight: bold;
      color: #586cb1;
    }
  }

  .header-right {
    display: flex;

    .el-menu {
      .is-active .el-sub-menu__title {
        color: #4b4b4b;
        font-size: 14px;
        border-bottom: none;
      }

      .el-sub-menu.is-active .el-sub-menu__title {
        border-bottom-color: none;
      }

      .el-sub-menu .el-sub-menu__title {
        padding: 0 10px;
        border-bottom: 0px;
      }

      .el-sub-menu__title {
        transition: none;
      }
    }
  }
}

// 展开与折叠button
.btn-primary {
  background: #586cb1;
  color: #ffffff;
  border: 1px solid #586cb1;

  &:hover,
  &:focus,
  &:active {
    background-color: #485faf;
    color: #ffffff;
    border: 1px solid #586cb1;
    box-shadow: none !important;
  }
}
</style>
